module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"text":"Du har {count} repetisjon i | Du har {count} repetisjoner i"},"en":{"text":"You have {count} repetition in | You have {count} repetitions in"}}')
  delete Component.options._Ctor
}
